import { Divider, Select } from "antd";
import type { SelectProps } from "antd";
import { PlusIcon } from "@phosphor-icons/react";
import { Button } from "@libertify/ui";
import { useNavigation, useTranslate } from "@refinedev/core";

type BrandKitSelectProps = {
  options?: SelectProps["options"];
  placeholder?: string;
  // Injected by the parent Form.Item.
  value?: string | null;
  onChange?: (value: string | null) => void;
};

export const BrandKitSelect = ({
  options,
  placeholder,
  value,
  onChange,
}: BrandKitSelectProps) => {
  const t = useTranslate();
  const { createUrl } = useNavigation();
  // Resolve the route from the resource, then open it in a new tab so the
  // user keeps their unsaved playbook edits.
  const brandKitCreateUrl = createUrl("media_brandkits");

  return (
    <Select
      value={value ?? undefined}
      onChange={(next) => onChange?.(next)}
      options={options}
      placeholder={placeholder}
      allowClear
      style={{ width: "100%" }}
      popupRender={(menu) => (
        <>
          {menu}
          <Divider style={{ margin: "4px 0" }} />
          <Button
            variant="tertiary"
            size="s"
            leftIcon={<PlusIcon size={16} />}
            onClick={() =>
              globalThis.open(
                brandKitCreateUrl,
                "_blank",
                "noopener,noreferrer"
              )
            }
            style={{ boxShadow: "none" }}
          >
            {t("pages.playbooks.createBrandkit")}
          </Button>
        </>
      )}
    />
  );
};
